import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
export function buildStore({ combinedReducers, initialState, middleware = [] }) {
    return createStore(combinedReducers, initialState, composeWithDevTools({})(applyMiddleware(...middleware)));
}
